<app-entity-page
  [closeClicked]="closeClicked"
  [detailsContentTitle]="(fragmentDetails?.fragmentTitle ?? '') | translateLang | async"
  [loading]="fragmentDetailsLoading">
  <ng-template #detailsContent>
    <div class="fragment-container">
      <div *ngIf="!fragmentDetailsLoading" class="fragment-layout">
        <div class="top-section" [attr.dir]="(currentLanguage$ | async) === 'he' ? 'rtl' : 'ltr'">

<div class="table">
  <div class="part">
    <span class="top">{{'iaa.app.fragment.manuscriptNum' | translate}}</span>
<span>                  <a class="manuscript-link" 
  role="navigation" 
  tabindex="0"
  (click)="goToManuscript()"
  (keydown.enter)="goToManuscript()"
  [attr.aria-label]="fragmentDetails?.manuscriptNum || ''">
 {{ fragmentDetails?.manuscriptNum || '-' }}
</a></span>
  </div >
  <div class="part">
    <span class="top">{{'iaa.app.fragment.fragmentNumber' | translate}}</span>
    <span class="bottom">{{ fragmentDetails?.fragNum || '-' }}</span>
  </div>
    <div class="part">
    <span class="top">{{'iaa.app.fragment.plateNumber' | translate}}</span>
    <span class="bottom">{{ fragmentDetails?.plateNumber || '-' }}</span>
  </div>
  <div class="part">
    <span class="top">{{'iaa.app.fragment.djdNumber' | translate}}</span>
    <span class="bottom">{{ fragmentDetails?.djdNumber || '-' }}</span>
  </div>

</div>
        </div>
   
        <div class="bottom-container">
          <div class="bottom-left">
            <span class="text-fragment-title">{{'iaa.app.fragment.manuscriptContent' | translate}} <i tabIndex="0" role="button" class="pi pi-info-circle"
              [ngClass]="{currentLang:true,'info-icon' : true, 'en': currentLanguage ==='en'}" tooltipEvent="both"
              [tooltipPosition]="currentLanguage === 'en' ? 'right' : 'left'"
              [attr.aria-description]=" 'iaa.app.fragment.iconExplanation' | translate "
              [attr.aria-label]="'iaa.aria.info' | translate " [pTooltip]=" 'iaa.app.fragment.iconExplanation' | translate "></i></span>
              <br>
            <app-text-fragment class="text-fragment" [fragmentLines]="fragmentLines"></app-text-fragment>
          </div>
          
          <div class="bottom-right">
              <app-iiif-tiled-viewer 
              class="viewer"
                [containerHeight]="400"
                [images]="viewerImages"
                [fitMode]="'fill-width'">
              </app-iiif-tiled-viewer>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</app-entity-page>